module.exports = __webpack_public_path__ + "img/ico038.bfb0bda4.svg";